import { render, staticRenderFns } from "./pexpertList.vue?vue&type=template&id=0019b787&scoped=true&"
import script from "./pexpertList.vue?vue&type=script&lang=js&"
export * from "./pexpertList.vue?vue&type=script&lang=js&"
import style0 from "./pexpertList.vue?vue&type=style&index=0&id=0019b787&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0019b787",
  null
  
)

export default component.exports